import { Program } from "@coral-xyz/anchor";
import { vsrResolvers } from "./resolvers";
import { PROGRAM_ID } from "./constants";
export * from "./constants";
export * from "./pdas";
export * from "./resolvers";
export const init = async (provider, programId = PROGRAM_ID, idl) => {
    if (!idl) {
        idl = await Program.fetchIdl(programId, provider);
    }
    const heliumVoterStakeRegistry = new Program(idl, programId, provider, undefined, () => {
        return vsrResolvers;
    });
    return heliumVoterStakeRegistry;
};
//# sourceMappingURL=index.js.map